<template>
  <div class='login-library'>
    <div v-loading='loading' class='content'>
      <h3>图书馆登录</h3>
      <input v-model='username' type='text' class='input' placeholder='请输入用户名'>
      <input v-model.trim='password' type='password' class='input' placeholder='请输入密码' @keyup.enter='login'>
      <div class='checkbox-wrapper'>
        <input id='check' v-model.trim='isRememberPwd' type='checkbox' name=''>
        <label for='check'>记住密码</label>
      </div>
      <a href='javascript:;' class='btn btn-login' @click='login'>登录</a>
      <a href='javascript:;' class='btn btn-cancel' @click='goBack'>取消</a>
    </div>
  </div>
</template>

<script>
import { LOGIN_LIBRARY } from '@/api'

export default {
  data() {
    return {
      loading: false,
      username: '',
      password: '',
      isRememberPwd: true
    }
  },

  created() {
    this.checkStroage()
  },
  methods: {
    // 登录
    login() {
      if (!this._validate()) return 
      let para = {
        username: this.username,
        password: this.password
      }
      this.loading = true
      LOGIN_LIBRARY(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.storeLibraryToken(res.data.data.library_user_token)
          if (this.isRememberPwd) this.rememberPwd()   // 记住密码
          else this.clearPwd()    // 清除密码

          this.$emit('successLogin')
        } else {
          this.notify(res.data.msg,'error')
        }
      })
    },

    // 记住密码
    rememberPwd() {
      localStorage.setItem('WAITU_LIBRARY_IS_REMEMBER_PWD',this.isRememberPwd)
      let account = {
        username: this.username,
        password: this.password
      }
      localStorage.setItem('WAITU_LIBRARY_ACCOUNT_INFO', JSON.stringify(account))
    },

    // 清除密码
    clearPwd() {
      localStorage.removeItem('WAITU_LIBRARY_IS_REMEMBER_PWD')
      localStorage.removeItem('WAITU_LIBRARY_ACCOUNT_INFO')
    },

    // 验证
    _validate() {
      if (!this.username) {
        this.$notify('请输入用户名','warning')
        return false
      }
      if (!this.password) {
        this.$notify('请输入密码','warning')
        return false
      }
      return true
    },

    // 取消
    cancel() {
      this.$emit('cancelLogin')
    },

    // 检测本地存储账号密码信息
    checkStroage() {
      let isRememberPwd = localStorage.getItem('WAITU_LIBRARY_IS_REMEMBER_PWD')
      if (isRememberPwd) {
        let account = localStorage.getItem('WAITU_LIBRARY_ACCOUNT_INFO')
        if (account) {
          this.username = JSON.parse(account).username
          this.password = JSON.parse(account).password
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.login-library {
  width: 100%;
  min-width: 1200px;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 500px;
    height: 370px;
    background-color: #ffffff;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    h3 {
      height: 46px;
      line-height: 46px;
      width: 100%;
      text-align: center;
      font-size: 20px;
      color: #ffffff;
      background: @blue-d;
    }

    .input {
      width: 310px;
      height: 40px;
      box-sizing: border-box;
      outline: none;
      border: 1px solid #cccccc;
      font-size: 16px;
      line-height: 40px;
      padding: 0 5px;
      border-radius: 5px;
      margin-top: 34px;
    }

    .checkbox-wrapper {
      width: 310px;
      margin: 20px 0;
      label {
        cursor: pointer;
        font-size: 12px;
      }
      input[type="checkbox"] {
        -webkit-appearance: checkbox;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    .btn {
      display: block;
      width: 310px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-size: 20px;
      color: #ffffff;
      border-radius: 5px;

      &.btn-login {
        background: @blue-d;
        margin-bottom: 18px;
      }

      &.btn-cancel {
        background: #cccccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginLibrary.vue